"use client";

import React, { createContext, useContext } from "react";
import { notification } from "antd";
import type { NotificationPlacement } from "antd/es/notification/interface";
import { translateRawRuntime } from "./i18n/rawTranslations";

type NotificationType = "success" | "info" | "warning" | "error";

interface NotifyParams {
  message: string;
  description?: string;
  placement?: NotificationPlacement;
  duration?: number;
}

const NotificationContext = createContext<any>(null);

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: NotificationType,
    { message, description, placement = "topRight", duration = 3 }: NotifyParams
  ) => {
    api[type]({
      message: translateRawRuntime(message),
      description: translateRawRuntime(description),
      placement,
      duration,
    });
  };

  const value = {
    notifySuccess: (params: NotifyParams) =>
      openNotification("success", params),
    notifyError: (params: NotifyParams) => openNotification("error", params),
    notifyInfo: (params: NotifyParams) => openNotification("info", params),
    notifyWarning: (params: NotifyParams) =>
      openNotification("warning", params),
  };

  return (
    <NotificationContext.Provider value={value}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
